module.exports = require('./helpers/bundle-url').getBundleURL('fw7YH') + "logo.c51670a8.svg";